import getConfig from "@/utils/getConfig";
import {OverwolfApi} from "@devour/client";
import {useQuery} from "@tanstack/react-query";

interface LauncherGameIdsResponse {
    gameIds: string[];
}

async function fetchLauncherGameIds(): Promise<LauncherGameIdsResponse> {
    return await (new OverwolfApi(getConfig()) as unknown as {
        getOverwolfGamesLaunchers: () => Promise<LauncherGameIdsResponse>;
    }).getOverwolfGamesLaunchers();
}

export default function useGetOverwolfLauncherGameIds() {
    return useQuery<LauncherGameIdsResponse>({
        queryKey: ["overwolf-launcher-game-ids"],
        queryFn: fetchLauncherGameIds,
        staleTime: 60 * 60 * 1000,
        gcTime: 24 * 60 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });
}
